import { FC, InputHTMLAttributes } from 'react'

import { Icons } from '../../../components/Icon'
import {
  FormColorVariants,
  type FormColorVariantValues,
} from '../../../types/form'

import * as SC from './styled'

export type FormFieldCheckboxProps = Omit<
  InputHTMLAttributes<HTMLInputElement>,
  'value'
> & {
  className?: string
  name: string
  checked?: boolean
  value?: string | number
  label?: string
  required?: boolean
  disabled?: boolean
  error?: string
  hasError?: boolean
  help?: string
  isGroupChild?: boolean
  colorVariant?: FormColorVariantValues
}

const FormFieldCheckbox: FC<FormFieldCheckboxProps> = ({
  className,
  label,
  error,
  hasError,
  help,
  isGroupChild,
  colorVariant = FormColorVariants.Primary,
  ...inputProps
}) => {
  return (
    <SC.Container className={className} $isDisabled={!!inputProps.disabled}>
      <SC.Label $isDisabled={!!inputProps.disabled}>
        <SC.Box>
          <SC.Checkbox
            {...inputProps}
            $variant={colorVariant}
            type="checkbox"
            $isError={isGroupChild ? false : !!error || hasError}
          />
          <SC.StyledIcon icon={Icons.check} />
        </SC.Box>

        <SC.LabelText
          $required={!!inputProps.required}
          $isError={isGroupChild ? false : !!error || hasError}
          dangerouslySetInnerHTML={{ __html: label ?? '' }}
        />
      </SC.Label>
      {!error && help && <SC.Help>{help}</SC.Help>}
      {error && <SC.Error>{error}</SC.Error>}
    </SC.Container>
  )
}

export default FormFieldCheckbox
